import { Col, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { formatCurrency } from '@opendoor/shared-fe/formatUtils';
import type { PropertyDetailsFragment } from '__generated__/athena/graphql';
import { formatStreetAddress } from 'components/marketplace/helpers';

import { PricingTraditional } from './Pricing';

interface PropertySummaryProps {
  property: PropertyDetailsFragment;
}
export const MiniMapPropertySummary = ({ property }: PropertySummaryProps) => {
  const formattedStreet = formatStreetAddress(
    property.street,
    property.unitType,
    property.unitNumber,
  );

  return (
    <Col className="lg:hidden">
      <Text as="h1" className="pb-6 text-subheader-xs font-normal text-od-content-primary">
        <Text as="span" className="text-subheader-xs font-normal">
          {formattedStreet}
        </Text>
        <br />
        <Text as="span" className="text-subheader-xs font-normal">
          {property.city}, {property.state} {property.zip}
        </Text>
      </Text>
      <Col as="section">
        <PricingTraditional listPrice={property?.listPrice} />
        <Row>
          <Text as="span" className="text-body-sm text-od-content-secondary">
            {property.bedrooms} bds
          </Text>
          <Text as="span" className="px-1 text-body-sm text-od-content-inactive-primary">
            ·
          </Text>
          <Text as="span" className="text-body-sm text-od-content-secondary">
            {property.bathrooms} ba
          </Text>
          <Text as="span" className="px-1 text-body-sm text-od-content-inactive-primary">
            ·
          </Text>
          <Text as="span" className="text-body-sm text-od-content-secondary">
            {property.sqFtTotalLiving} sqft
          </Text>
          <Text as="span" className="px-1 text-body-sm text-od-content-inactive-primary">
            ·
          </Text>
          <Text className="text-body-sm text-od-content-secondary">
            {property?.estimatedMonthlyPayment &&
              `${formatCurrency(property?.estimatedMonthlyPayment)}/month est.`}
          </Text>
        </Row>
        <Row>
          <Text as="span" className="text-body-sm text-od-content-secondary">
            {!!property?.schoolDistricts?.length && `${property?.schoolDistricts?.join(' & ')}`}
          </Text>
        </Row>
      </Col>
    </Col>
  );
};
